import { asyncRouterMap, constantRouterMap } from '@/router';

function getPermissionList(roles, permissionList = []) {
  for (let index = 0; index < roles.length; index++) {
    const el = roles[index];
    if (el.menuGrade < 3) {
      permissionList.push(el.menuCode);
    }
    if (el.childrenMenus && el.childrenMenus.length) {
      getPermissionList(el.childrenMenus, permissionList);
    }
  }
  return permissionList;
}
function getPermissionListApi(roles, permissionList = []) {
  for (let index = 0; index < roles.length; index++) {
    const el = roles[index];
    if (el.menuGrade === 3) {
      permissionList.push(el.menuCode);
    }
    if (el.childrenMenus && el.childrenMenus.length) {
      getPermissionListApi(el.childrenMenus, permissionList);
    }
  }
  return permissionList;
}
function hasPermission(permissionList, route) {
  if (route.meta && route.meta.permission) {
    let flag = false;
    for (let i = 0; i < permissionList.length; i++) {
      const el = permissionList[i];
      flag = route.meta.permission.includes(el);
      if (flag) {
        return true;
      }
    }
    return false;
  }
  return true;
}
function filterAsyncRouter(routerMap, roles, permissionList) {
  const accessedRouters = routerMap.filter((route) => {
    /**
     * 找到roles中存在 path
     * 存在则判断是否有权限访问
     * 没有权限干掉改path， 进度下一条寻找
     */
    if (hasPermission(permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles, permissionList);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

const state = {
  asyncRouterMap,
  routers: constantRouterMap,
  addRouters: [],
  permissionList: [],
  permission: []
  // permission: storage.get('permission', [])
};
const getters = {};
const mutations = {
  SET_ROUTERS: (state, routers) => {
    state.addRouters = routers;
    state.routers = constantRouterMap.concat(routers);
  },
  SET_PERMISSIONLIST: (state, permissionList) => {
    state.permissionList = permissionList;
  },
  SET_PERMISSIONAPI: (state, permission) => {
    state.permission = permission;
  }
};
const actions = {
  GenerateRoutes({ commit, ...params }, roles) {
    console.log('🚀 ~ file: permission.js ~ line 81 ~ GenerateRoutes ~ params', params);
    console.log(`读取路由配置`, params.state.asyncRouterMap);
    const permissionList = getPermissionList(roles) || [];
    const permission = getPermissionListApi(roles) || [];
    return new Promise((resolve) => {
      const accessedRouters = filterAsyncRouter(asyncRouterMap, roles, permissionList);
      commit('SET_PERMISSIONLIST', permissionList);
      commit('SET_PERMISSIONAPI', permission);
      commit('SET_ROUTERS', accessedRouters);
      resolve(accessedRouters);
    });
  }
};

export default { state, getters, mutations, actions };



// WEBPACK FOOTER //
// ./src/store/modules/permission.js